var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-menu"},[_c('div',{staticClass:"logo_mobile"},[_c('div',{staticClass:"logo-glow"}),_vm._v(" "),_c('img',{attrs:{"src":"/imgs/logo.png","alt":"logo"},on:{"click":function($event){return _vm.$router.replace({ name: 'index' })}}})]),_vm._v(" "),_c('LmobileMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }